import React, { useState } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material';

const CriarCliente = ({ apiBaseURL }) => {
    const [open, setOpen] = useState(false);
    const [nomeCliente, setNomeCliente] = useState('');
    const [email, setEmail] = useState('');

    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const handleSubmit = () => {
        // Exemplo de payload para criar o cliente
        const novoCliente = {
            nome: nomeCliente,
            email: email
        };

        fetch(`${apiBaseURL}/api/clientes`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(novoCliente)
        })
        .then(response => response.json())
        .then(data => {
            console.log('Cliente criado: ', data);
            handleClose();
        })
        .catch(err => {
            console.error('Erro ao criar cliente: ', err);
        });
    };

    return (
        <div>
            <Button variant="contained" color="primary" onClick={handleOpen}>
                Criar Cliente
            </Button>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Criar Novo Cliente</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Nome do Cliente"
                        fullWidth
                        value={nomeCliente}
                        onChange={(e) => setNomeCliente(e.target.value)}
                    />
                    <TextField
                        margin="dense"
                        label="Email"
                        type="email"
                        fullWidth
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancelar</Button>
                    <Button onClick={handleSubmit} variant="contained" color="primary">
                        Criar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default CriarCliente;
